import React from 'react'
import PropTypes from 'prop-types'
import { Grid, TextField } from '@the-platform-group/component-library'
import { Select } from '@the-platform-group/component-library/Select'

import { AGENTIC_PROMPT_STATUSES } from 'constants/agenticPrompts'
import { usePromptMetadata } from 'hooks/usePromptMetadata'

const statusOptions = AGENTIC_PROMPT_STATUSES.map(status => ({
  value: status,
  label: status,
}))

const filterInputHeight = { '& .MuiOutlinedInput-root': { height: 40 } }

const PromptFilters = ({
  filters,
  onSearch,
  onWorkflowsChange,
  onCategoriesChange,
  onStatusesChange,
}) => {
  const { workflowOptions, appDomainOptions } = usePromptMetadata()

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item md={3} xs={12}>
        <TextField
          fullWidth
          placeholder="Search by title or body"
          defaultValue={filters.term ?? ''}
          onChange={onSearch}
          sx={filterInputHeight}
        />
      </Grid>
      <Grid item md={3} xs={12}>
        <Select
          fullWidth
          isMulti
          margin="none"
          options={workflowOptions}
          value={filters.workflows || []}
          onChange={event => onWorkflowsChange(event.target.value)}
          placeholder="Filter by workflow"
          sx={filterInputHeight}
        />
      </Grid>
      <Grid item md={3} xs={12}>
        <Select
          fullWidth
          isMulti
          margin="none"
          options={appDomainOptions}
          value={filters.categories || []}
          onChange={event => onCategoriesChange(event.target.value)}
          placeholder="Filter by app domains"
          sx={filterInputHeight}
        />
      </Grid>
      <Grid item md={3} xs={12}>
        <Select
          fullWidth
          isMulti
          margin="none"
          options={statusOptions}
          value={filters.statuses || []}
          onChange={event => onStatusesChange(event.target.value)}
          placeholder="Filter by status"
          sx={filterInputHeight}
        />
      </Grid>
    </Grid>
  )
}

PromptFilters.propTypes = {
  filters: PropTypes.shape({
    term: PropTypes.string,
    workflows: PropTypes.arrayOf(PropTypes.string),
    categories: PropTypes.arrayOf(PropTypes.string),
    statuses: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  onSearch: PropTypes.func.isRequired,
  onWorkflowsChange: PropTypes.func.isRequired,
  onCategoriesChange: PropTypes.func.isRequired,
  onStatusesChange: PropTypes.func.isRequired,
}

export default PromptFilters
